import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import {
	ModalDialogueCaptionModifier,
	ModalDialogueHeader
} from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-header/ModalDialogueHeader';
import { ModalDialogueSection } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSection';
import { ModalDialogueSectionName } from 'presentation/ui/compositions/modal-dialogue/modal-dialogue-section/ModalDialogueSectionName';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonSecondary, ButtonSecondaryStatus } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';
import { IconIdentifier } from 'presentation/ui/partials/icon/IconIdentifier';
import { CyclotronProductViewModel } from 'services/nuclide/domain/model/CyclotronProductModel';
import { ContainerViewModel } from '../../../../domain/model/ContainerModel';

export interface CyclotronProductToSingleNuclidesFormProps {
	cyclotronProduct: CyclotronProductViewModel;
	onToSingleNuclides: () => void;
	onDismiss: () => void;
	container?: ContainerViewModel;
	isLastItem?: boolean;
}

export const CyclotronProductToSingleNuclidesForm = (props: CyclotronProductToSingleNuclidesFormProps): JSX.Element => {
	const { cyclotronProduct, onToSingleNuclides, onDismiss, isLastItem } = props;

	// Consume the context
	const l10nContext = useContext(L10nContext);

	const deliveryDatetimeFormatted = l10nContext.formatDate(cyclotronProduct.DeliveryDate);

	const modalMessage = {
		first: l10nContext.translate('view.cyclotronProducts.modal.action.toSingleNuclides.message.first', 'Wollen Sie das Radionuklid vom '),
		last: l10nContext.translate('view.cyclotronProducts.modal.action.toSingleNuclides.message.last', 'wirklich vom Gebinde lösen?'),
		lastItem: l10nContext.translate('view.cyclotronProducts.modal.action.toSingleNuclides.message.lastItem', ' Dies ist das letzte Element im Gebinde, das Gebinde wird gelöscht.')
	};

	return (
		<>
			<ModalDialogueHeader
				captionText={l10nContext.translate('common.modal.captionAttention', 'Achtung')}
				captionIcon={IconIdentifier.ALERT}
				captionModifier={ModalDialogueCaptionModifier.SMALL_CAPTION}
			/>
			<ModalDialogueSection>
				<>
					{modalMessage.first} <b>{deliveryDatetimeFormatted}</b> {modalMessage.last}
					{isLastItem ? modalMessage.lastItem : null}
				</>
			</ModalDialogueSection>

			<ModalDialogueSection section={ModalDialogueSectionName.SECTION_FOOTER}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={l10nContext.translate('common.button.abort', 'Abbrechen')}
							onClick={onDismiss}
						/>
					</ColumnLayoutSection>
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonSecondary
							buttonText={
								isLastItem ? l10nContext.translate('common.modal.toSingleNuclides.setToSingleNuclidesConfirmDeleteContainer', 'Ja, vom Gebinde lösen und Gebinde löschen')
									: l10nContext.translate('common.modal.toSingleNuclides.setToSingleNuclidesConfirm', 'Ja, vom Gebinde lösen')
							}
							status={ButtonSecondaryStatus.ATTENTION}
							icon={IconIdentifier.DECAY}
							onClick={onToSingleNuclides}
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</ModalDialogueSection>
		</>
	);
};
